export function getAccountBadgeStatusDateText(t, status, expiresAt, statusLastUpdatedAt) {
    if (status === 'valid') {
        return t('badges.badgeDetails.accountBadgeTable.dateLabels.expiresOn', {
            date: new Date(expiresAt).toLocaleDateString(),
        });
    }
    if (status === 'expired') {
        return t('badges.badgeDetails.accountBadgeTable.dateLabels.expiredOn', {
            date: new Date(expiresAt).toLocaleDateString(),
        });
    }
    if (status === 'revoked' && statusLastUpdatedAt) {
        return t('badges.badgeDetails.accountBadgeTable.dateLabels.revokedOn', {
            date: new Date(statusLastUpdatedAt).toLocaleDateString(),
        });
    }
    return '';
}
